// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__fWWkA","current":"style_current__cBtf1","arrow":"style_arrow__3cvLz"};